module.exports = __webpack_public_path__ + "static/media/russia.2434e4f0.svg";